// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment_modal_container .modal2__container{
    width: 40%;
}

.payments_active_modal{
    padding: 16px;
}

.payments_active_modal-information{
    display: grid;
    align-content: center;
    justify-content: center;
    justify-items: center;
    padding-bottom: 40px;
    padding-left: 64px;
    padding-right: 64px;
}

.payments_active_modal-box{

    align-items: center;
    justify-content: space-between;
    padding: 0 64px;
}

.payments_active_modal .input-field{
    margin:0 130px;

}

.payments_active_modal-container.busuness{
    margin-bottom: 30px;
}

.payments_active_modal_button{
    display: flex;
    justify-content: flex-end;
    margin-top: var(--space-x2);
    padding-top: var(--space);
    border-top: solid 1px var(--new-input-background-color);
}

.payments_active_modal .select-field-input{
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-half);
}

.payments_active_modal-box .MuiInput-underline::before{
    border-bottom:none;
    content: none;
}

.payments_active_modal-container.location{
    padding-bottom: 20px;
}

.payments_active_modal_title .select-field-label{
    color: var(--black-color);

}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .payment_modal_container .modal2__container{
        width: 100%;
    }

    .payments_active_modal-box{
        align-items: center;
        justify-content: space-between;
        padding: 0px;
    }

    .payments_active_modal-information{
        display: grid;
        align-content: center;
        justify-content: center;
        justify-items: center;
        padding: 20px  0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/payments/components/payments-active-modal/PaymentsActiveModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,uDAAuD;AAC3D;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB,uBAAuB;QACvB,qBAAqB;QACrB,gBAAgB;IACpB;AACJ","sourcesContent":[".payment_modal_container .modal2__container{\n    width: 40%;\n}\n\n.payments_active_modal{\n    padding: 16px;\n}\n\n.payments_active_modal-information{\n    display: grid;\n    align-content: center;\n    justify-content: center;\n    justify-items: center;\n    padding-bottom: 40px;\n    padding-left: 64px;\n    padding-right: 64px;\n}\n\n.payments_active_modal-box{\n\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 64px;\n}\n\n.payments_active_modal .input-field{\n    margin:0 130px;\n\n}\n\n.payments_active_modal-container.busuness{\n    margin-bottom: 30px;\n}\n\n.payments_active_modal_button{\n    display: flex;\n    justify-content: flex-end;\n    margin-top: var(--space-x2);\n    padding-top: var(--space);\n    border-top: solid 1px var(--new-input-background-color);\n}\n\n.payments_active_modal .select-field-input{\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-half);\n}\n\n.payments_active_modal-box .MuiInput-underline::before{\n    border-bottom:none;\n    content: none;\n}\n\n.payments_active_modal-container.location{\n    padding-bottom: 20px;\n}\n\n.payments_active_modal_title .select-field-label{\n    color: var(--black-color);\n\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .payment_modal_container .modal2__container{\n        width: 100%;\n    }\n\n    .payments_active_modal-box{\n        align-items: center;\n        justify-content: space-between;\n        padding: 0px;\n    }\n\n    .payments_active_modal-information{\n        display: grid;\n        align-content: center;\n        justify-content: center;\n        justify-items: center;\n        padding: 20px  0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
